import useNetwork from '@/hooks/use-network';
import { Info } from 'lucide-react';
import { Button } from './ui/button';

const SyncContent = ({
  isSyncing,
  onSync,
}: {
  isSyncing: boolean;
  onSync: () => void;
}) => {
  return (
    <div className="fixed bottom-4 right-4 z-10 bg-slate-200 p-2 px-4 rounded-lg">
      <div className="flex items-center gap-2">
        <Info className="h-6 w-6" />
        <div>
          <p className="text-md text-black">
            {isSyncing ? 'Syncing...' : 'Not synced'}
          </p>
          <p className="text-sm text-black">
            Please wait for the sync to complete.
          </p>
        </div>
        <div>
          <Button variant="outline" onClick={onSync}>
            {isSyncing ? 'Syncing...' : 'Sync now'}
          </Button>
        </div>
      </div>
    </div>
  );
};

const CustomSync = (props: {
  isSynced: boolean;
  isSyncing: boolean;
  onSync: () => void;
}) => {
  const { isOnline } = useNetwork();

  return (
    !props.isSynced &&
    isOnline && (
      <SyncContent
        isSyncing={props.isSyncing}
        onSync={() => {
          props.onSync();
        }}
      />
    )
  );
};

export default CustomSync;
